import { shell, Eyebrow, Title, CTA, serif, SubTitle } from "../components/CommonComponents";

const Structure = ({ programStructure, title }) => {
    return (
        <section id="structure" className="relative scroll-mt-6 bg-[#EEF4F8] py-20 sm:py-24 lg:py-28">
            <div className={shell}>
                <Eyebrow>Academic route</Eyebrow>
                <Title highlight="Curriculum &amp; Program Structure" position="end">
                    {title}
                </Title>
                <SubTitle>Replace the sample subjects with the approved syllabus for the selected programme.</SubTitle>
                <div className="mt-12 overflow-x-auto pb-4">
                    <div className="flex min-w-[900px] items-stretch">
                        {programStructure.map((x, i) => (
                            <div
                                key={x.title}
                                className={`relative flex-1 border-y border-l border-[#071A2F]/15 p-6 last:border-r ${i === programStructure.length - 1 ? "bg-[#8B1E3F] text-white" : "bg-white"}`}
                            >
                                <div>
                                    <span className="text-sm font-bold text-[#D5AD57]">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <h4 className={`${serif} mt-5 text-2xl`}>{x.title}</h4>
                                    <p className="mt-8 text-sm">{x.credits} credits</p>
                                    <strong className="mt-2 block">{x.marks} marks</strong>
                                </div>
                                {i < programStructure.length - 1 && (
                                    <span className="absolute -right-3 top-1/2 z-10 grid h-6 w-6 -translate-y-1/2 place-items-center rounded-full bg-[#D5AD57] text-[#071A2F]">
                                        →
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Structure;
